module.exports = __webpack_public_path__ + "img/bg_small_gray.c57117ef.svg";